module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/prize-frame-167483c015ba38e092530e2184e4637b.png";